module.exports = __webpack_public_path__ + "static/media/popupcard_1.107e04d7.png";